import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {toPriceStr} from '@/utils';
import {useAgentDataStore} from './agent-data.store';
import AgentDateRangeFilter, {useAgentDateRange} from './AgentDateRangeFilter';
import AgentDataTable from './AgentDataTable';
import stickySurfaceStyles from './refer-earn-sticky-surface.module.scss';
import {useStickyActive} from './use-sticky-active';

const columns = ['userId', 'team', 'betAmounts', 'commission'] as const;
const tableGridClassName = 'grid-cols-[1fr_0.75fr_1.35fr_1.55fr]';
const formatAmount = (value?: string | number) =>
  toPriceStr(Number(value || 0) || 0, {thousands: true, fixed: 2});

const CommissionContent = () => {
  const {t} = useTranslation();
  const {range, dateRangeValue, setDateRangeValue} = useAgentDateRange();
  const commissionList = useAgentDataStore(state => state.commissionList);
  const commissionLoading = useAgentDataStore(state => state.commissionLoading);
  const loadCommissionData = useAgentDataStore(
    state => state.loadCommissionData,
  );
  const {active: stickyActive, sentinelRef} = useStickyActive();
  const rows = commissionList?.content || [];

  useEffect(() => {
    loadCommissionData(range);
  }, [loadCommissionData, range]);

  return (
    <section className="px-0 pb-4">
      <span ref={sentinelRef} aria-hidden="true" className="block h-px" />
      <div
        className={[
          stickyActive ? stickySurfaceStyles.stickySurface : '',
          stickyActive ? stickySurfaceStyles.dataControlsSurface : '',
          'sticky top-[3.0625rem] z-20 -mx-2 bg-transparent px-2 py-[0.875rem]',
        ].join(' ')}>
        <AgentDateRangeFilter
          className="w-[11.9375rem] max-w-full"
          range={range}
          value={dateRangeValue}
          onChange={setDateRangeValue}
        />
      </div>

      <AgentDataTable
        loading={commissionLoading}
        empty={!rows.length}
        emptyText={t('invitation.agentData.noData')}
        gridClassName={tableGridClassName}
        columns={columns.map(column =>
          t(`invitation.commission.columns.${column}`),
        )}>
        {rows.map((row, index) => (
          <div
            key={`${row.userId}-${index}`}
            className={[
              'grid h-10 items-center px-3 text-[0.75rem] font-normal leading-[1.144rem] text-black',
              tableGridClassName,
              index % 2 === 1 ? 'bg-[rgba(140,140,140,0.06)]' : '',
            ].join(' ')}>
            <div className="truncate text-center">{row.userId}</div>
            <div className="truncate text-center">{row.teamLevel}</div>
            <div className="truncate text-center">
              {formatAmount(row.betAmount)}
            </div>
            <div className="truncate text-center">
              {formatAmount(row.betCommissionAmount)}
            </div>
          </div>
        ))}
      </AgentDataTable>
    </section>
  );
};

export default CommissionContent;
